import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { searchResultsExecutionStatus } from '@as-react/common-types';
import { uniqueId } from '@as-react/common-utils';
import { Box, Link, Stack } from '@yonderland/andes-react';
import { Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { ComparePopupContainer } from '../../../containers/ComparePopupContainer';
import { partialSearchActions } from '../../../redux/partialsSearch/actions/PartialsSearchActions.creators';
import { ProductGroupCarousel } from '../../product-group/ProductGroupCarousel';
import { useProductListerContext } from '../context';
import { PartialSearchResultsBanner } from './PartialSearchResultsBanner';
const getProductGroupUniqueIds = (alternativeQueryResults) => {
    if (!(alternativeQueryResults === null || alternativeQueryResults === void 0 ? void 0 : alternativeQueryResults.length)) {
        return {};
    }
    return alternativeQueryResults.reduce((acc, item) => {
        if (item.alternativeQuery) {
            acc[uniqueId('productGroup-')] = item.alternativeQuery;
        }
        return acc;
    }, {});
};
const makeProductGroupObjects = (productGroupUniqueIds, alternativeQueryResults) => {
    const productGroupObjects = {};
    if (productGroupUniqueIds && alternativeQueryResults) {
        Object.keys(productGroupUniqueIds).forEach((productGroupKey) => {
            var _a, _b;
            productGroupObjects[`${productGroupKey}`] =
                (_b = (_a = alternativeQueryResults.find(item => item.alternativeQuery === productGroupUniqueIds[`${productGroupKey}`])) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : [];
        });
    }
    return productGroupObjects;
};
export const PartialSearchResults = () => {
    var _a;
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const aemConfiguration = useAemConfig();
    const { root, feature_toggles } = aemConfiguration;
    const dispatch = useDispatch();
    const { urlState: { q: query }, query: { data: { executionStatus, alternativeQueryResults } = {} }, } = useProductListerContext();
    const productGroupUniqueIds = getProductGroupUniqueIds(alternativeQueryResults);
    const productGroup = makeProductGroupObjects(productGroupUniqueIds, alternativeQueryResults);
    useEffect(() => {
        dispatch(partialSearchActions.createInitializeAction());
    }, []);
    const alternativeBrandSuggestionTitle = (_a = alternativeQueryResults === null || alternativeQueryResults === void 0 ? void 0 : alternativeQueryResults[0]) === null || _a === void 0 ? void 0 : _a.alternativeQuery;
    const getFormattedTitles = (productGroupIdKey) => {
        const availableTerm = productGroupUniqueIds[productGroupIdKey];
        if (productGroup[productGroupIdKey].length < 1) {
            return null;
        }
        const hasSpacedSearchTerm = query === null || query === void 0 ? void 0 : query.includes(' ');
        const initialSearchTerms = hasSpacedSearchTerm ? query === null || query === void 0 ? void 0 : query.split(' ') : query === null || query === void 0 ? void 0 : query.split('+');
        const formattedTitles = initialSearchTerms === null || initialSearchTerms === void 0 ? void 0 : initialSearchTerms.map(item => {
            return { [item]: availableTerm === null || availableTerm === void 0 ? void 0 : availableTerm.includes(item.toLowerCase()) };
        });
        return initialSearchTerms === null || initialSearchTerms === void 0 ? void 0 : initialSearchTerms.map((item, index) => {
            var _a;
            return !((_a = formattedTitles === null || formattedTitles === void 0 ? void 0 : formattedTitles[index]) === null || _a === void 0 ? void 0 : _a[item]) ? (_jsxs(Fragment, { children: [_jsx("del", { children: item.trim() }), ' '] }, index)) : (_jsxs("span", { children: [item.trim(), " "] }, index));
        });
    };
    const findAlternativeQueryItemCount = (productGroupKey) => { var _a; return (_a = alternativeQueryResults === null || alternativeQueryResults === void 0 ? void 0 : alternativeQueryResults.find(item => item.alternativeQuery === productGroupUniqueIds[productGroupKey])) === null || _a === void 0 ? void 0 : _a.itemCount; };
    const getAlternativeQueryButtonLabel = (productGroupKey) => {
        return t('productlister.search.show.alternatives_plural', {
            count: findAlternativeQueryItemCount(productGroupKey) || 1,
        });
    };
    const hasUndefinedItems = Object.keys(productGroupUniqueIds).some(productGroupKey => productGroupUniqueIds[productGroupKey] === undefined);
    if (hasUndefinedItems)
        return null;
    const getLink = (productGroupKey) => {
        if (!productGroup[productGroupKey] || productGroup[productGroupKey].length <= 1) {
            return;
        }
        return (_jsx(Link, { theme: "neutral", variant: "secondary", size: "md", href: `${root}lister.html?q=${encodeURIComponent(productGroupUniqueIds[productGroupKey])}`, children: getAlternativeQueryButtonLabel(productGroupKey) }));
    };
    return (_jsx(Box, { paddingBlockEnd: { base: '8', lg: '10' }, children: _jsxs(Stack, { direction: "col", gap: { base: 8, lg: 10 }, children: [_jsx(PartialSearchResultsBanner, {}), Object.keys(productGroupUniqueIds).map(productGroupKey => (_jsx(ProductGroupCarousel, { title: executionStatus === searchResultsExecutionStatus.ALT_BRAND
                        ? alternativeBrandSuggestionTitle
                        : getFormattedTitles(`${productGroupKey}`), link: getLink(productGroupKey), productGroupId: productGroupKey, productGroup: productGroup }, productGroupKey))), feature_toggles.product_compare && _jsx(ComparePopupContainer, {})] }) }));
};
